<template>
  <div class="act-history">
    <Modal
      v-model="show"
      title="操作记录"
      width="900"
      max-height="500"
      :footer-hide="true"
      border
      @on-ok="handleOk"
      @on-cancel="handleCancel"
    >
      <div class="search" style="margin-bottom: 16px">
        <Form ref="formInline" inline>
          <FormItem>
            <Input
              v-model="keyWord"
              type="text"
              placeholder="请输入操作说明关键字检索"
              style="width: 220px"
              clearable
            >
            </Input>
          </FormItem>
          <Button type="primary" @click="handleSearch">查询</Button>
        </Form>
      </div>
      <div class="main" style="padding-bottom: 32px">
        <Table :columns="columns" :data="data">
          <template slot="actType" slot-scope="{ row }">
            {{ row.actType | initActType }}
          </template>
          <template slot="remark" slot-scope="{ row }">
            {{ row.remark }}
            <!-- <TablePoptip :content="row.remark" :content-width="350" :show-poptips-content-length="24"> </TablePoptip> -->
          </template>
        </Table>
      </div>
      <div class="page-main" style="text-align: right">
        <Page
          show-total
          show-elevator
          :total="pageInfo.total"
          :current="pageInfo.pageNum"
          :page-size="pageInfo.pageSize"
          @on-change="handlePage"
        ></Page>
      </div>
    </Modal>
  </div>
</template>

<script>
import courseSchedulCenter from '@/request/courseSchedulCenter/index.js';
export default {
  name: 'ActHistory',
  filters: {
    initActType(actType) {
      switch (Number(actType)) {
        case 1:
          return '后台操作入班';
          break;
        case 2:
          return '学生离班';
          break;
        case 3:
          return '调整上课日期';
          break;
        case 4:
          return '任课老师调整';
          break;
        case 4:
          return '编辑课班信息';
          break;
        case 5:
          return '调整课班信息';
          break;
        case 6:
          return '调整排课规则';
          break;
        case 7:
          return '学生节次转班';
          break;
      }
    }
  },
  props: {
    classroomId: {
      type: String,
      default: ''
    } // 班级id
  },
  data() {
    return {
      show: false,
      columns: [{
        title: '操作类型',
        slot: 'actType',
        width: 150
      }, {
        title: '操作人',
        key: 'operateName',
        width: 150
      }, {
        title: '操作时间',
        key: 'createTime',
        width: 180
      }, {
        title: '说明',
        slot: 'remark',
        minWidth: 180
      }],
      data: [],
      keyWord: '',
      pageInfo: {
        pageNum: 1,
        pageSize: 10,
        total: 0
      }
    };
  },
  methods: {
    handleCancel() {

    },
    handleOk() {

    },
    handleOpen() {
      this.show = true;
      this.pageInfo.pageNum = 1;

      this.getActHistoryList();
    },
    // 查询
    handleSearch() {
      this.pageInfo.pageNum = 1;
      this.getActHistoryList();
    },
    handlePage(page) {
      this.pageInfo.pageNum = page;
      this.getActHistoryList();
    },
    // 操作记录列表
    async getActHistoryList() {
      this.data = [];
      const res = await courseSchedulCenter.getActHistoryList({
        keyWord: this.keyWord,
        classroomId: this.classroomId,
        pageNum: this.pageInfo.pageNum,
        pageSize: this.pageInfo.pageSize
      });

      if (res.status == 200) {
        this.data = res.message.list;
        this.pageInfo.total = Number(res.message.total);
      }
    }
  }
};
</script>
